import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const emailsUrl = "/api/v2/email/share-article";

export interface ShareArticleModel extends BaseModel {
    FriendsName: string;
    FriendsEmailAddress: string;
    YourName: string;
    YourEmailAddress: string;
    YourMessage: string;
    ArticleImage: string;
    ArticleDescription: string;
    AltText: string;
    ArticleUrl: string;
}

export interface ShareArticleParameter {
    FriendsName: string;
    FriendsEmailAddress: string;
    YourName: string;
    YourEmailAddress: string;
    YourMessage: string;
    ArticleImage: string;
    ArticleDescription: string;
    AltText: string;
    ArticleUrl: string;
    onSuccess?: () => void;
}

export interface ShareArticleApiParameter extends ApiParameter {
    shareArticleModel: ShareArticleModel;
}

export function shareArticleService(parameter: ShareArticleApiParameter) {
    return post<ShareArticleModel>(`${emailsUrl}`, parameter.shareArticleModel);
}
